<template>
  <div>
    <div class="title">班级信息</div>
    <ul class="classInfo">
      <li>
        <p>班级名称：{{baseInfo.class_name}}</p>
      </li>
      <li>
        <div class="f-left">
          <p>所属课程：{{baseInfo.course_name}}</p>
          <p>创建时间：{{baseInfo.created_at}}</p>
        </div>
        <div class="f-left">
          <p>讲师名称：{{baseInfo.teacher_name}}</p>
          <p>助教名称：{{baseInfo.assistant_name}}</p>
        </div>
      </li>
      <li>
        <p>班级介绍：{{baseInfo.description?baseInfo.description:"无"}}</p>
      </li>
      <li>
        <p>班级概述：记录学员数共有{{baseInfo.student_number}}人，其中订单正常{{baseInfo.order_complete_number}}人，已退单{{baseInfo.order_refund_number}}人，不支持删除订单正常的班级学员，支持删除已退单的学员，已退单学员只做信息记录，不占班级人员名额</p>
      </li>
    </ul>
    <div class="title">学员信息</div>
    <Form :model="searchCondition" :label-width="100" inline>
      <FormItem label="学员名称">
        <Input
          v-model="searchCondition.nickname"
          placeholder="请输入学员名称关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="search(1)"
        ></Input>
      </FormItem>
      <FormItem label="手机号">
        <Input
          v-model="searchCondition.mobile"
          placeholder="请输入手机号关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="search(1)"
        ></Input>
      </FormItem>
      <FormItem label="订单状态">
        <Select v-model="searchCondition.order_status" style="width:200px;" clearable>
          <Option v-for="item in order_state" :key="item.key" :value="item.key">{{item.value}}</Option>
        </Select>
      </FormItem>
      <Form-item label="加入班级时间">
        <Date-picker
          :editable="false"
          ref="formDate"
          type="datetimerange"
          placeholder="开始日期 — 结束日期"
          style="width:280px;"
          @on-change="onDateRange"
          @keydown.native.prevent.enter="onSearch"
          clearable
        ></Date-picker>
      </Form-item>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div>
      <Button
        type="primary"
        :to="{name: 'ClassGradeStudent',query:{type: 'classGradeStudent', course_basis_id:baseInfo.course_basis_id,class_grade_id:baseInfo.id}}"
        style="margin-right:10px;"
      >导入学员</Button>
      <Button type="primary" @click="onMineChange">移除退单学员</Button>
    </div>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        :data-url="`/api/classGradeStudent/student/${id}`"
        :search="searchCondition"
        @onSelectionChange="onSelectionChange"
        :rowsFormatter="rowsFormatter"
        selectType="multi"
        keyField="id"
        method="get"
      >
        <template slot-scope="{row}" slot="action">
          <div>
            <Button
              type="text"
              size="small"
              @click="turnClass(row.student_id)"
              :disabled="row.order_status == 3"
            >调班</Button>
            <span>-</span>
            <Button
              type="text"
              size="small"
              :to="{name:'StudentOrderList', query:{mobile: row.mobile,type:'OrderCourse'}}"
            >查看订单</Button>
            <span>-</span>
            <Button
              type="text"
              size="small"
              @click="onRecord(row)"
              :disabled="row.order_status == 3"
            >学习记录</Button>
            <span v-if="showHomeworkModule">-</span>
            <Button
              type="text"
              size="small"
              v-if="showHomeworkModule"
              :to="{name:'StudentHomeworkList', query:{student_id: row.student_id,class_grade_id:row.class_grade_id}}"
            >学员作业列表</Button>
            <span>-</span>
            <Button
              type="text"
              size="small"
              @click="onForbidden(row.student_id)"
              :disabled="row.order_status == 2"
            >删除</Button>
          </div>
        </template>
        <template slot="footer-left">
          <Button
            class="btn-margin-right"
            size="small"
            @click="turnClass(0)"
            :disabled="selectItems.length==0"
          >调班</Button>
          <Button
            class="btn-margin-right"
            size="small"
            @click="onForbidden(0)"
            :disabled="selectItems.length==0"
          >删除</Button>
        </template>
      </Grid>
    </div>
    <Modal
      class="grid-select"
      v-model="showSelectClass"
      title="选择班级"
      @on-ok="confirmSelectClass"
      @on-cancel="$refs.class.recoverSelectedItems(classes)"
      width="800"
      scrollable
    >
      <classes
        ref="class"
        :selectedItems="classes"
        selectType="single"
        :course_name="baseInfo.course_name"
        :autoLoadData="false"
      ></classes>
    </Modal>
    <Modal v-model="modal.show" title="学习记录" width="800">
      <div>
        <Button type="primary" @click="onExportRecord">批量导出</Button>
      </div>
      <div class="content">
        <Grid
          ref="modalGrid"
          :columns="modal.columns"
          :data-url="modal.dataUrl"
          :search="modal.searchCondition"
          :rowsFormatter="onModalRowsFormatter"
          selectType
          keyField="course_basis_id"
          method="get"
        ></Grid>
      </div>
    </Modal>
  </div>
</template>
<script>
import { ClassOrderState, CouseType } from "@/utils/enums";
import classes from "@/components/GridSelect/ClassSelect";
export default {
  name: "ClassManage",
  components: { classes },
  data() {
    return {
      id: this.$route.query.id,
      order_state: ClassOrderState.getOptions(),
      searchCondition: {
        nickname: "",
        mobile: "",
        order_status: "",
        start_time: "",
        end_time: "",
        init: function() {
          this.nickname = "";
          this.mobile = "";
          this.order_status = "";
          this.start_time = "";
          this.end_time = "";
        }
      },
      onlyShowMe: false,
      tableColumns: [
        { title: "学员名称", key: "nickname", minWidth: 180 },
        { title: "手机号", key: "mobile", minWidth: 180, align: "center" },
        { title: "订单金额", key: "order_price", minWidth: 100 },
        {
          title: "订单状态",
          key: "order_status_name",
          minWidth: 120,
          align: "center"
        },
        {
          title: "加入班级时间",
          key: "created_at",
          minWidth: 160,
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          fixed: "right",
          minWidth: 240,
          align: "center"
        }
      ],
      classes: [],
      baseInfo: {},
      selectItems: [],
      showSelectClass: false,
      ids: "",
      modal: {
        show: false,
        columns: [
          { title: "课程名称", key: "title", minWidth: 120 },
          { title: "课程类型", key: "course_type_name", minWidth: 100 },
          { title: "课时数量", key: "chapter_total", minWidth: 100 },
          { title: "学习进度", key: "study_ratio", minWidth: 120 }
        ],
        dataUrl: "",
        searchCondition: {
          user_id: ""
        }
      },
      showHomeworkModule: false
    };
  },
  async created() {
    let commonSetting = await this.$http.get("/api/commonSetting");
    this.showHomeworkModule = commonSetting.homework_module.is_open == 1;

    this.getClassBase();
  },
  methods: {
    onRecord(row) {
      this.modal.show = true;
      this.modal.searchCondition.user_id = row.student_id;
      this.modal.dataUrl = "/api/user/study";
      this.$nextTick(() => {
        this.$refs.modalGrid.searchRefresh();
      });
    },
    onModalRowsFormatter(rows) {
      rows.forEach(i => {
        i.course_type_name = CouseType.getValue(i.course_type);
        i.study_ratio = parseInt(i.study_ratio * 100) + "%";
      });
    },
    onExportRecord() {
      if (!this.$refs.modalGrid.getTotal()) {
        this.$Message.info("暂无数据可导出");
        return;
      }
      this.$http
        .get("/api/user/study/export/" + this.modal.searchCondition.user_id)
        .then(data => {
          window.open(data.url);
        });
    },
    rowsFormatter(rows) {
      rows.forEach(item => {
        item.order_price = (item.order_price / 100).toFixed(2);
        item.order_status_name = ClassOrderState.getValue(item.order_status);
        item.created_at = this.$pub.timestampToTime(item.created_at);
      });
    },
    search(flag) {
      if (flag == 0) {
        this.$refs.formDate.handleClear();
        this.searchCondition.init();
      }
      this.$refs.grid.searchRefresh();
      this.selectItems = [];
    },
    onMineChange() {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确定要移除已退单学员吗？</p>",
        onOk: () => {
          this.$http
            .delete(`/api/classGradeStudent/refundStudent/${this.id}`)
            .then(() => {
              this.$Message.createSuccess("移除成功");
              this.search(1);
            });
        }
      });
    },
    onSelectionChange(items) {
      this.selectItems = items;
    },
    /**
     * @param {String} id   班级
     */
    onForbidden(id) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确定要删除该学员吗？</p>",
        onOk: () => {
          this.nextAction(id);
        }
      });
    },
    nextAction(id) {
      let ids = "";
      if (id) {
        ids = id;
      } else {
        this.selectItems.forEach(item => {
          ids += item.student_id + ",";
        });
        ids = ids.substr(0, ids.length - 1);
      }
      this.$http
        .delete(`/api/classGradeStudent/student/${ids}`, {
          class_grade_id: this.id
        })
        .then(() => {
          this.$Message.deleteSuccess();
          this.$refs.grid.searchRefresh();
          this.selectItems = [];
        });
    },
    onDateRange(range) {
      this.searchCondition.start_time = range[0];
      this.searchCondition.end_time = range[1];
    },
    getClassBase() {
      this.$http
        .get(`/api/classGradeStudent/classBase/${this.id}`)
        .then(res => {
          res.created_at = this.$pub.timestampToTime(res.created_at);
          this.baseInfo = res;
        });
    },
    confirmSelectClass() {
      this.showSelectClass = false;
      let list = this.$refs.class.getSelectList();
      this.classes = list;
      this.$http
        .post(`/api/classGradeStudent/move`, {
          to_class_grade_id: list[0].id,
          class_grade_id: this.id,
          student_id: this.ids
        })
        .then(() => {
          this.$Message.createSuccess("调班成功");
          this.search(1);
        });
    },
    turnClass(id) {
      this.ids = "";
      if (id) {
        this.ids = id;
      } else {
        this.selectItems.forEach(item => {
          this.ids += item.student_id + ",";
        });
        this.ids = this.ids.substr(0, this.ids.length - 1);
      }
      this.showSelectClass = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.classInfo {
  padding: 0 30px 30px;
  li {
    line-height: 38px;
    font-size: 14px;
    overflow: hidden;
    p {
      padding-right: 80px;
    }
  }
}
</style>